<template>
  <v-container>
    <v-row>
      <v-col cols="auto">
        <v-avatar :color="avatarColor" size="48">
          <span class="white--text">{{ from.substr(0, 2).toUpperCase() }}</span>
        </v-avatar>
      </v-col>

      <v-col>
        <v-row no-gutters justify="space-between" align="start">
          <v-col class="from-to">
            <p>{{ $t('notifications.item.from') }} {{ from }}</p>
            <p class="text-caption"> {{ sentDate }} </p>
          </v-col>
          <v-col md="auto" cols="auto"></v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h4>{{ title }}</h4>
            <div v-html="text" class="notification-content"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import strToColor from "@/utils/strToColor";

export default {
  name: "MessageView",
  props: {
    from: String,
    title: String,
    text: String,
    sentDate: String,
  },
  computed: {
    avatarColor() {
      return strToColor(this.from);
    }
  }
}
</script>

<style scoped lang="scss">
.from-to {
  p {
    margin-bottom: 0;
    font-size: 11px;
    font-weight: bold;
  }
}
</style>